module.exports = __webpack_public_path__ + "img/main-btn.8d6e8087.png";